// ----------------------------------------------------------------------------
// Nombre del Programa : Enlaces
// Autor               : Daniel Medina
// Compania            : Forward
// Proyecto/Procliente : P-24-1448-21                      Fecha: 18/AGO/2023
// Descripcion General : Clase que se utiliza la vista y funciones de el listado de roles de usuario
// Programa Dependiente: N/A
// Programa Subsecuente: N/A
// Cond. de ejecucion  : N/A
// Dias de ejecucion   : N/A                                 Horario: N/A
//                              MODIFICACIONES
// ----------------------------------------------------------------------------
// Numero de Parametros:
// Parametros Entrada  :                                    Formato:
//
// Parametros Salida   : N/A                                Formato: N/A
// ----------------------------------------------------------------------------

import './RolesPermisos.scss';
import 'react-status-alert/dist/status-alert.css';
import { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import Table from 'react-bootstrap/Table';
import { Button } from 'react-bootstrap';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { StatusAlertService } from 'react-status-alert';
import Simplert from 'react-simplert';
import { Paginador } from '../../components/paginador/Paginador';
import { RolProps } from '../../interfaces/rolesInterfaces';
import { getRoli } from '../../Utilidades/session';
import { getRoles, deleteRol } from '../../Services/RolesService';

export const RolesPermisos = () => {
  const PAGE_SIZE = 8;
  const [pagActual, setPagActual] = useState<number>(0);

  const [roles, setRoles] = useState<RolProps[]>([]);
  const [cargado, setCargado] = useState<boolean>(false);
  const [mostrarAlerta, setMostrarAlerta] = useState<boolean>(false);
  const [rolBorrar, setRolBorrar] = useState<{ idp: number; index: number }>({
    idp: 0,
    index: 0,
  });

  useEffect(() => {
    getRoles().then((response) => {
      if (response.data && response.data.data) {
        setRoles(response.data.data);
        setCargado(true);
      }
    });
  }, []);

  const borrarRol = async (idp: number, index: number) => {
    if (getRoli() === String(idp)) {
      StatusAlertService.showError(
        'No puedes borrar el rol al que estas asignado'
      );
      return;
    }
    let indexBorrar = pagActual * PAGE_SIZE + index;
    setRolBorrar({ idp: idp, index: indexBorrar });
    setMostrarAlerta(true);
  };
  const confirmarBorrarRol = async () => {
    setMostrarAlerta(false);
    setCargado(false);
    const response: any = await deleteRol(rolBorrar.idp).catch(({ response }) => {
      const { data } = response;
      StatusAlertService.showError(data.meta.message);
      setCargado(true);
    });
    if (response.data && response.data.data) {
      roles.splice(rolBorrar.index, 1);
      setCargado(true);
      StatusAlertService.showSuccess('Borrado Exitosamente');
    }
  };

  const rolesMostrar = () =>
    roles.filter(
      (_, i) =>
        i >= PAGE_SIZE * pagActual && i <= PAGE_SIZE * pagActual + PAGE_SIZE - 1
    );

  const cambiarPagina = (pag) => {
    setPagActual(pag);
  };

  //console.log('roles:', roles);
  //console.log('nrolll:', nrol);

  return (
    <>
      <Simplert
        showSimplert={mostrarAlerta}
        type="info"
        title="¿Desea Eliminarlo?"
        message="Al borrarlo se quitara el rol de todos los usuarios asignados"
        customCloseBtnText="Cancelar"
        customConfirmBtnText="Aceptar"
        customConfirmBtnClass="btn-confirm"
        customCloseBtnClass="btn-cerrar"
        disableOverlayClick={true}
        useConfirmBtn={true}
        onConfirm={() => confirmarBorrarRol()}
        onClose={() => setMostrarAlerta(false)}
      />
      <div className="m-5">
        <Row>
          <Col className="heading-1">Roles y permisos</Col>
        </Row>
        <div className="d-flex flex-row-reverse bd-highlight mb-3">
          <Link to={'/roles-permisos/detalle-rol/0'}>
            <Button variant="primary" className="float-end">
              Crear nuevo rol
            </Button>
          </Link>
        </div>
        <Table responsive>
          <thead className="colorgray2">
            <tr>
              <th>Nombre</th>
              <th>Usuarios</th>
              <th>Fecha de creación</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {roles.length > 0 ? (
              rolesMostrar().map((rol, index) => (
                <tr key={rol.tiporol_id} className="colorgray2">
                  <td
                    className={
                      index === 0 ? '' : index === roles.length - 1 ? '' : ''
                    }
                  >
                    {rol.nombreRol}
                  </td>
                  <td>{rol.totalUsrRol}</td>
                  <td>{moment(rol.fecInserta).format('DD/MM/YYYY')}</td>
                  <td
                    className={
                      index === 0 ? '' : index === roles.length - 1 ? '' : ''
                    }
                    width="140"
                  >
                    <Button
                      variant="secondary"
                      className="btntable me-2"
                      onClick={() => borrarRol(rol.tiporol_id, index)}
                    >
                      <div className="material-icons">delete</div>
                    </Button>
                    <Link to={'/roles-permisos/detalle-rol/' + rol.tiporol_id}>
                      <Button variant="secondary" className="btntable">
                        <div className="material-icons">edit</div>
                      </Button>
                    </Link>
                  </td>
                </tr>
              ))
            ) : cargado ? (
              <tr className="colorgray2">
                <td className="nodatos    " colSpan={4}>
                  No Existen Datos
                </td>
              </tr>
            ) : (
              <tr></tr>
            )}
          </tbody>
        </Table>
        <Row>
          <Paginador
            tamanoPagina={PAGE_SIZE}
            totalRegistros={roles.length}
            paginaCambiada={cambiarPagina}
          ></Paginador>
        </Row>
      </div>
    </>
  );
};
